import { render, staticRenderFns } from "./NewEventsTable.vue?vue&type=template&id=773d09be&scoped=true&"
import script from "./NewEventsTable.vue?vue&type=script&lang=ts&"
export * from "./NewEventsTable.vue?vue&type=script&lang=ts&"
import style0 from "./NewEventsTable.vue?vue&type=style&index=0&id=773d09be&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d09be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
